import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Header from '../../components/Header';
import Title from '../../components/Title';
import { TbStarsFilled } from "react-icons/tb"
import { db } from '../../services/firebaseConnection';
import { addDoc, collection } from 'firebase/firestore';
import { toast } from 'react-toastify';
import { Container, Row, Col, Button } from 'react-bootstrap';

export default function Cargo() {
  const todasPermissoes = [
    "home",
    "calendario",
    "deletar_itens",


    "relatorio_lista",
    "relatorio_novo",
    "relatorio_editar",


    "usuario_lista",
    "usuario_novo",
    "usuario_editar",


    "cidade_lista",
    "cidade_novo",
    "cidade_editar",



    "cargo_lista",
    "cargo_novo",
    "cargo_editar",

    "igreja_lista",
    "igreja_novo",
    "igreja_editar"
  ];

  const [nome, setNome] = useState('');
  const [permissoes, setPermissoes] = useState([]);
  const [tipo, setTipo] = useState('');
  const navigate = useNavigate();

  const handlePermissionChange = (event) => {
    const { value, checked } = event.target;
    setPermissoes((prevPermissoes) => {
      if (checked) {
        return [...prevPermissoes, value];
      } else {
        return prevPermissoes.filter((permission) => permission !== value);
      }
    });
  };

  const handleSelectAll = (event) => {
    if (event.target.checked) {
      setPermissoes(todasPermissoes);
    } else {
      setPermissoes([]);
    }
  };

  async function handleRegister(e) {
    e.preventDefault();
    if (nome !== '' && tipo !== '') {
      await addDoc(collection(db, 'Cargo'), {
        nome: nome,
        permissoes: permissoes,
        tipo: tipo
      })
        .then(() => {
          setNome('');
          setPermissoes([]);
          setTipo('');
          toast.success('Cargo registrado!');
          navigate('/cargo');
        })
        .catch((error) => {
          console.log(error);
          toast.error('Erro ao fazer o cadastro.');
        });
    } else {
      toast.error('Preencha todos os campos!');
    }
  }

  return (
    <div>
      <Header />

      <div className="content">
        <Title name="Cargo">
          <TbStarsFilled size={25} />
        </Title>

        <Container>
          <form className="form-profile" onSubmit={handleRegister}>
            <Row className="mb-3">
              <Col>
                <label>Nome</label>
                <input
                  type="text"
                  placeholder="Nome do cargo"
                  value={nome}
                  onChange={(e) => setNome(e.target.value)}
                  className="form-control input-name"
                />
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <br></br>
                <label>Permissões</label>
                <label id="all-permissions">
                  <input
                    type="checkbox"
                    value="todos"
                    checked={permissoes.length === todasPermissoes.length}
                    onChange={handleSelectAll}
                    className="form-check-input"
                  />
                  &nbsp;Marcar todas as opções
                </label>
                <div className="permissions-container">
                  {todasPermissoes.map((permissao) => (
                    <label key={permissao}>
                      <input
                        type="checkbox"
                        value={permissao}
                        checked={permissoes.includes(permissao)}
                        onChange={handlePermissionChange}
                      />
                      {permissao.replace('_', ' ')}
                    </label>
                  ))}
                </div>
              </Col>
            </Row>

            <Row className="mb-3">
              <Col>
                <br></br>
                <label>Tipo</label>
                <div className="radio-container">
                  <label>
                    <input
                      type="radio"
                      label="Administradores"
                      value="Admin"
                      checked={tipo === 'Admin'}
                      onChange={(e) => setTipo(e.target.value)}
                    />
                    Administradores
                  </label>
                  <label>
                    <input
                      type="radio"
                      label="Porteiros / Auxiliares da Porta"
                      value="UserP"
                      checked={tipo === 'UserP'}
                      onChange={(e) => setTipo(e.target.value)}
                    />
                    Porteiros / Auxiliares da Porta
                  </label>
                  <label>
                    <input
                      type="radio"
                      label="Operadores de Som"
                      value="UserS"
                      checked={tipo === 'UserS'}
                      onChange={(e) => setTipo(e.target.value)}
                    />
                    Operadores de Som
                  </label>
                </div>
              </Col>
            </Row>

            <Button type="submit" variant="primary">
              Salvar
            </Button>
          </form>
        </Container>
      </div>
    </div>
  );
}
